export default {
  name: "Agent/Attorney (Firm) Profile",
  sections: [
    {
      name: "Agent/Attorney - Identifiers",
      fields: [
        {
          machine_name: "new_profile_atty_agent_dba",
          widget: "text",
          label: "Law Firm/Business Name",
          validate: ["required"],
          maxLength: 120,
          tooltip:
            "Enter the full trade name or 'Doing Business As' (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application.",
        },
        {
          machine_name: "new_profile_atty_agent_fein",
          widget: "text",
          label: "<span>Federal Employer Identification Number <i>(FEIN from IRS)</i></span>",
          tooltip:
            "Enter the nine-digit Federal Employer identification Number (FEIN) as assigned by the IRS.  Do not enter a social security number. Important Note: All employers, including private households, MUST obtain an FEIN from the IRS before completing this application.  Information on obtaining an FEIN can be found at <a target='_blank' href='http://www.irs.gov'>www.irs.gov</a>.",
          maxLength: 10,
          parse: "fein",
          validate: ["required", "fein", { minLength: 10 }],
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_atty_agent_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 60,
          tooltip: "Enter a unique name that will allow you to identify this profile",
          validate: ["required"],
        },
      ],
    },
  ],
};
